import { CHANNEL, type Channel } from 'src/data/channel';

export const FILTER_ASSET_TYPE = {
  allAssets: 'all_assets',
  title: 'title',
  text: 'text',
} as const;
export type FilterAssetType = (typeof FILTER_ASSET_TYPE)[keyof typeof FILTER_ASSET_TYPE];

const FILTER_ASSET_TYPE_PROPS: {
  [filter in FilterAssetType]: { label: Record<string, string> };
} = {
  [FILTER_ASSET_TYPE.allAssets]: {
    label: {
      default: 'All asset types',
    },
  },
  [FILTER_ASSET_TYPE.title]: {
    label: {
      [CHANNEL.google]: 'Headline',
      [CHANNEL.facebook]: 'Headline',
      [CHANNEL.linkedin]: 'Headline',
      [CHANNEL.hubspot]: 'Subject',
      [CHANNEL.salesforce]: 'Subject',
      [CHANNEL.marketo]: 'Subject',
      [CHANNEL.braze]: 'Subject',
      [CHANNEL.iterable]: 'Subject',
      [CHANNEL.salesforceExactTarget]: 'Subject',
      default: 'Headline',
    },
  },
  [FILTER_ASSET_TYPE.text]: {
    label: {
      [CHANNEL.google]: 'Description',
      [CHANNEL.facebook]: 'Primary text',
      [CHANNEL.linkedin]: 'Copy',
      [CHANNEL.hubspot]: 'Body',
      [CHANNEL.salesforce]: 'Body',
      [CHANNEL.marketo]: 'Body',
      [CHANNEL.braze]: 'Body',
      [CHANNEL.iterable]: 'Body',
      [CHANNEL.salesforceExactTarget]: 'Body',
      default: 'Description',
    },
  },
};

export const getFilterAssetType = (filterAssetType: FilterAssetType, channel: Channel): string => {
  const labels = FILTER_ASSET_TYPE_PROPS?.[filterAssetType]?.label;
  return labels?.[channel] || labels?.default || '';
};
